import { queryOptions } from '@tanstack/react-query';

import { getHeySynclyPromptLibraryList } from './get-prompt-library-list';

export const heySynclyPromptLibraryQueryKeys = {
  all: ['hey-syncly', 'prompt-libraries'] as const,
  list: (workspaceId: string) =>
    [...heySynclyPromptLibraryQueryKeys.all, workspaceId] as const,
};

export const heySynclyPromptLibraryListQueryOptions = (
  workspaceId: string,
  options?: { enabled?: boolean },
) =>
  queryOptions({
    queryKey: heySynclyPromptLibraryQueryKeys.list(workspaceId),
    queryFn: async () => {
      const response = await getHeySynclyPromptLibraryList({
        workspace_id: workspaceId,
      });

      return response.list;
    },
    enabled: !!workspaceId && (options?.enabled ?? true),
  });
